export const DATE_FORMAT_API = 'YYYY-MM-DD';
export const DATE_FORMAT_LONG = 'ddd DD/MMM/YYYY';
export const DATE_FORMAT_SHORT = 'DD/MMM/YYYY';
export const DAY_FORMAT_SHORT = 'ddd';
export const DAY_MONTH_FORMAT = 'DD MMM';
export const MINUTES_SECONDS_FORMAT = 'mm:ss';
export const MONTH_YEAR_FORMAT = 'MMMM-YYYY';
export const TIME_FORMAT_LONG = 'HH:mm:ss';
export const TIME_FORMAT_SHORT = 'HH:mm';
export const TIME_FORMAT_IN_MINUTES_LONG = 'mm:ss.S';
export const TIME_FORMAT_FULL = 'HH:mm:ss.S';
export const MONTH_SHORT_FORMAT = 'MMM';
export const YEAR_FORMAT = 'YYYY';
export const YEAR_MONTH_FORMAT = 'YYYY-MM';
export const DAY_MONTH_DATE = 'ddd MMM DD';
export const LUXON_DATE_FORMAT_LONG = 'EEE dd/MMM/y';
export const LUXON_DATE_FORMAT_FULL = 'EEE dd/MMM/y HH:mm';
